import contract_sign from "@/views/order/orderDialog/contractSign.vue";

export default {
  components: {
    contract_sign,
  },
  data() {
    return {
      env: process.env,
      orderId: "",
      order: {
        orderId: "",
      },
      loading: false,
    };
  },
  created() {
    this.orderId = this.$route.params.id || 0;
    this.order.orderId = this.$route.params.id || 0;
    this.loading = true;
    setTimeout(() => {
      this.loading = false;
      this.getContractData();
    }, 2000);
  },
  methods: {
    getContractData() {
      this.$refs.contract_sign_dialog.getContractData(this.orderId, false, this.order, false, true, true);
    },
    buttonSubmit(item, order) {
      console.log("buttonSubmit", item, order);
      switch (item.buttonCode) {
        case "to_multiple_pay_by_gray_setting":
          this.$message.error(item.buttonMsg);
          window.location.href = `/v/order/detail/${this.orderId}`;
          return;
        case "to_multiple_pay_by_confirm":
          this.$message.error(item.buttonMsg);
          window.location.href = `/v/order/detail/${this.orderId}`;
          return;
        case "to_multiple_pay":
          window.location.href = `${process.env.VUE_APP_APP}order/person/toOrderFractionalPayment?orderId=${order.orderId}&type=1`;
          return;
        case "to_pay_by_gray_setting":
          this.$message.error(item.buttonMsg);
          window.location.href = `/v/order/detail/${this.orderId}`;
          return;
        case "to_pay_by_confirm":
          this.$message.error(item.buttonMsg);
          window.location.href = `/v/order/detail/${this.orderId}`;
          return;
        case "to_pay":
          this.selOrderToPayByOrderId(order.orderId);
          return;
        case "to_pay_juge_contract":
          window.location.href = `/v/order/detail/${this.orderId}`;
          return;
        default:
          this.$message.error("无效按钮");
          window.location.href = `/v/order/detail/${this.orderId}`;
          return;
      }
    },
    selOrderToPayByOrderId(orderId) {
      this.$store.dispatch("orderTo/index/selOrderToPayByOrderId", { orderId: orderId }).then((data) => {
        if (!data.isAllowPayment) {
          this.$message.error("您没有支付权限");
          return;
        }
        // 签署代付协议
        if (data.isBuildPaymentOnBehalfTreaty == "1") {
          this.$confirm("您正在替其他用户或企业支付该笔订单，请签署相关代付协议后再支付？", "提示", {
            confirmButtonText: "签署",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              this.openOrderToPayBox("如果没弹出签署页面，可能被您的浏览器拦截了！请检查浏览器设置", "我已完成签署", "遇到问题，重试");
              window.open(`${process.env.VUE_APP_APP}v/treaty/paymentOnBehalfTreaty?isShowTitle=1&orderId=${orderId}`);
            })
            .catch(() => {});
          return;
        }
        // 个人认证
        if (data.isBuildPaymentOnBehalfTreaty == "2") {
          this.$confirm("您正在替其他用户或企业支付该笔订单，请先进行实名认证后再支付？", "提示", {
            confirmButtonText: "去认证",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              this.openOrderToPayBox("如果没弹出认证页面，可能被您的浏览器拦截了！请检查浏览器设置", "我已完成认证", "遇到问题，重试");
              window.open(`${process.env.VUE_APP_JR}yue_openAccount_auth.html?retUrl=${window.location.href}`);
            })
            .catch(() => {});
          return;
        }
        // 企业认证
        if (data.isBuildPaymentOnBehalfTreaty == "3") {
          this.$confirm("您正在替其他用户或企业支付该笔订单，请先进行实名认证后再支付？", "提示", {
            confirmButtonText: "去认证",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              this.openOrderToPayBox("如果没弹出认证页面，可能被您的浏览器拦截了！请检查浏览器设置", "我已完成认证", "遇到问题，重试");
              window.open(`${process.env.VUE_APP_JR}yueOrgRegister.html?retUrl=${window.location.href}`);
            })
            .catch(() => {});
          return;
        }
        if (data.isBuildPaymentOnBehalfTreaty == "4") {
          this.$message.error("下单用户或企业未完成实名认证，您无法替该用户或企业支付该笔订单");
          return;
        }

        if (!data.isToPay) {
          this.$message.error(data.isToPayMsg);
          return;
        }
        window.location.href = `${process.env.VUE_APP_APP}payment/chectout/bkCheckout/${orderId}`;
      });
    },
  },
};
